@if (selectedBluePrint) {
<div class="div-right-panel-component">
  <form [formGroup]="myForm">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput maxlength="255" #inputName required (focus)="selectName()" type="text" formControlName="name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>
    <div class="save-button-div" *ngIf="!isReadOnly">
      <button mat-raised-button color="primary" (click)="saveWork()" [disabled]="!myForm.valid || !myForm.dirty">Save</button>
    </div>
  </form>
</div>
}
